import { render, staticRenderFns } from "./ChatHistoryPage.vue?vue&type=template&id=df9f3b82&scoped=true"
import script from "./ChatHistoryPage.vue?vue&type=script&lang=js"
export * from "./ChatHistoryPage.vue?vue&type=script&lang=js"
import style0 from "./ChatHistoryPage.vue?vue&type=style&index=0&id=df9f3b82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9f3b82",
  null
  
)

export default component.exports